import classNames from 'classnames';

export function Divider(props) {
    const {className} = props;

    const dividerClasses = classNames('divider', className);

    return <hr className={dividerClasses} />;
}
